"use client";
import { useSyncExternalStore } from "react";
import { calendarDateInTimeZone } from "@utils/core";

const DAY_CHECK_INTERVAL_MS = 60_000;

const subscribeToMinutes = (onChange: () => void) => {
  const id = setInterval(onChange, DAY_CHECK_INTERVAL_MS);
  return () => clearInterval(id);
};
const getServerDay = () => null;

/**
 * Today's date (`YYYY-MM-DD`) in `timeZone` — the location's day, which the
 * openings API reads `date` in and which can differ from the visitor's
 * (BF-DEC-015). Without a zone it is the browser's own day. Rechecked every
 * minute, so a page left open across the location's midnight moves on with
 * it. `null` on the server and during hydration: the server's clock is not
 * the browser's, and any date text rendered from it fails hydration (#553).
 * Render nothing derived from "today" until this returns a day.
 */
export function useLocationDay(
  timeZone: string | null | undefined,
): string | null {
  return useSyncExternalStore(
    subscribeToMinutes,
    () => calendarDateInTimeZone(new Date(), timeZone),
    getServerDay,
  );
}
